import React, { Component } from 'react';
import './ContactForm.css';

class ContactForm extends Component {
  constructor(){
    super();
      this.state = {
        message: '',
        name: '',
        email: '',
        subject: ''
      }
  }

  handleChange(e){
    const {name, value} = e.target
    this.setState({[name]: value})
  }

  handleSubmit(e){
    e.preventDefault();
  }

  render() {
    return (
      <div className='cf-container'>
        <div className="contact-form">
          <h1> Ready to build your Idea? </h1>
          <form onSubmit={this.handleSubmit}>
          <input className='input' type="text" onChange={this.handleChange} placeholder='Enter your Name' name="name" value={this.state.name} />
          <input className='input' type="email" onChange={this.handleChange} placeholder='Contact Email' name="email" value={this.state.email} />
          <input className='input' type="text" onChange={this.handleChange} placeholder='Name/Type of Project' name="subject" value={this.state.subject} />
            <label>
              Essay:
              <textarea className='input p-desc' onChange={this.handleChange} name="message" value={this.state.message} 
              placeholder='Tell us about your project'
              onChange={this.handleChange} />
            </label>
            <input type="submit" className='input submit' value="Submit" />
          </form>
        </div>
      </div>
    );
  }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/ContactForm/ContactForm.js